// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ql-mention-list-container {
  width: 270px;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 2px 12px 0 rgba(30, 30, 30, 0.08);
  z-index: 99999;
  overflow: auto;
}

.ql-mention-loading {
  line-height: 44px;
  padding: 0 20px;
  vertical-align: middle;
  font-size: 14px;
}

.ql-mention-list {
  list-style: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.ql-mention-list-item {
  cursor: pointer;
  line-height: 44px;
  font-size: 14px;
  padding: 0 20px;
  vertical-align: middle;
}

.ql-mention-list-item.disabled {
  cursor: auto;
}

.ql-mention-list-item.selected {
  background-color: var(--color-gray-100);
  text-decoration: none;
}

.mention {
  height: 24px;
  border-radius: 6px;
  background-color: transparent;
  padding: 0;
  margin-right: 2px;
  user-select: all;
  color: #2563eb; /* text-blue-600 */
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
}

.mention > span {
  margin: 0;
  color: #2563eb; /* text-blue-600 */
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/components/quill-mention/quill.mention.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,+CAA+C;EAC/C,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uCAAuC;EACvC,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,cAAc,EAAE,kBAAkB;EAClC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc,EAAE,kBAAkB;EAClC,gBAAgB;AAClB","sourcesContent":[".ql-mention-list-container {\n  width: 270px;\n  border: 1px solid #f0f0f0;\n  border-radius: 4px;\n  background-color: #ffffff;\n  box-shadow: 0 2px 12px 0 rgba(30, 30, 30, 0.08);\n  z-index: 99999;\n  overflow: auto;\n}\n\n.ql-mention-loading {\n  line-height: 44px;\n  padding: 0 20px;\n  vertical-align: middle;\n  font-size: 14px;\n}\n\n.ql-mention-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n}\n\n.ql-mention-list-item {\n  cursor: pointer;\n  line-height: 44px;\n  font-size: 14px;\n  padding: 0 20px;\n  vertical-align: middle;\n}\n\n.ql-mention-list-item.disabled {\n  cursor: auto;\n}\n\n.ql-mention-list-item.selected {\n  background-color: var(--color-gray-100);\n  text-decoration: none;\n}\n\n.mention {\n  height: 24px;\n  border-radius: 6px;\n  background-color: transparent;\n  padding: 0;\n  margin-right: 2px;\n  user-select: all;\n  color: #2563eb; /* text-blue-600 */\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.mention > span {\n  margin: 0;\n  color: #2563eb; /* text-blue-600 */\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
